export const saveSelectedPlanData = (selectedPlan, paymentInfo) => {
  return {
    type: 'SAVE_DATA',
    payload: {selectedPlan, paymentInfo}
  };
};

export const saveIsTrialData = (isTrial) => {
  return {
    type: 'SAVE_TRIAL_DATA',
    payload: {isTrial}
  }

};

export const resetSelectedPlanData = () => {
  return {
    type: 'RESET_DATA',
  };
};
